/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import Value from 'components/value';
import { formatDateTime } from 'common/helpers/format';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import PrimaryButton from 'components/form/buttons/primaryButton';
import EventFilterPopup from '../filterForm';

import * as S from './styles';
import * as T from 'common/types';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

interface IProps {
  data: [];
  departments: [];
  ticketCategory: [];
  loading: boolean;
}

export default function EventsTable({ data, departments, ticketCategory, loading }: IProps) {
  const { ticketsRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 1000,
    search: '',
    type: ''
  });

  const fetchData = () => {
    ticketsRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  // const handleChangePage = (page: number) => {
  //   setMeta({ ...meta, page });
  // };

  // const handleChangePageSize = (page_size: number) => {
  //   setMeta({ ...meta, page_size });
  // };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox onChange={(e) => setMeta({ ...meta, search: e })} placeholder="Search" />
          <EventFilterPopup
            setFilter={setMeta}
            filter={meta}
            departments={departments}
            ticketCategory={ticketCategory}
          />
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, key: 'id', title: 'ID', dir: 'left', width: 72 },
            { id: 4, key: 'title', title: 'Title', dir: 'left' },
            { id: 5, key: 'type', title: 'Type', dir: 'left', width: 110 },
            { id: 6, key: 'capacity', title: 'Capacity', dir: 'left', width: 100 },
            { id: 7, key: 'department', title: 'Department', dir: 'left', width: 120 },
            { id: 8, key: 'createdAt', title: 'Date', dir: 'left', width: 156 },
            { id: 9, key: 'edit', title: 'Edit', type: 'actions', width: 64 },
            { id: 10, key: 'requestLocation', title: '', type: 'actions', width: 110 }
          ]}
          data={data}
          loading={loading}
          altanfeethiFields={{
            id: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item?.id}</S.Div>,

            title: (item: T.Pages.TicketItem) => <S.Div className="text-left captal">{item.title}</S.Div>,
            type: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item.category?.title}</S.Div>,
            capacity: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item?.requestLocation}</S.Div>,
            department: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item.category?.title}</S.Div>,
            createdAt: (item: T.Pages.TicketItem) => (
              <S.Div className="text-left captal">
                <Value mono>{formatDateTime(item.createdAt)}</Value>
              </S.Div>
            ),
            edit: (item: T.Pages.TicketItem) => (
              <Link to={`/panel/events/${item.id}`}>
                <ReactSVG
                  src="/icons/stroke/pen-card.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('stroke', `#8A93AC`);
                    // svg.setAttribute("width", `12px`);
                    // svg.setAttribute("heigth", `12px`);
                  }}
                  wrapper="span"
                />
              </Link>
            ),
            requestLocation: (item: T.Pages.TicketItem) => (
              <S.Div className="text-left captal">
                <PrimaryButton
                  link={`/panel/events/contributors/${item.id}`}
                  className="secondary sm"
                  style={{ margin: 'auto' }}
                >
                  Details
                </PrimaryButton>
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
      {/* {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )} */}
    </S.Content>
  );
}
